module.exports = __webpack_public_path__ + "img/cancelIncomeSecond.ef6c4369.svg";